import { en } from './en/en';
import { de } from './de/de';

export const i18n = {
    en,
    de
};
